import { ID } from 'app/common/ui-next/_filter-compilations/predefined-ids'
import { canMailingTo } from 'app/common/ui-next/_filter-compilations/mailing'
import { apiStringFromReportType } from '../../../data/_predefined/api-string-from-report-type'
import { ReportType } from 'app/dataTypes/reports'

export type ApiCorrectionsParams = {
  report_type: string
  params: {
    from: string
    to: string
    operation_type: 'purchases' | 'subsidies' //  тип операции, purchases - продажи, subsidies - дотации
    operation_age: 'selected' | 'all' //          давность операции, all - все время, selected - выбранный период
    limits: {
      school_ids: number[]
    }
  }
  options?: {
    send_to_email?: string // отправить на почту
  }
}

const getFormDataFromSelector = (formItem: ID, formData: FormData) => {
  const value = formData.getAll(formItem) as Array<string> | undefined
  if (value && value.length) return value
  return []
}

export const convertParams = (formData: FormData): [ApiCorrectionsParams, null] => {
  const orgIDs = getFormDataFromSelector(ID.org, formData)
  const operationsType = formData.get(ID.operationsType) as 'purchases' | 'subsidies'
  const operationsAge = formData.get(ID.operationAge) as 'selected' | 'all'
  const periodFrom = formData.get(`${ID.periodDateFormat}From`) as string
  const periodTo = formData.get(`${ID.periodDateFormat}To`) as string
  const email = canMailingTo(formData)
  const options = email ? { send_to_email: email } : {}
  return [
    {
      report_type: apiStringFromReportType(ReportType.Corrections),
      params: {
        from: periodFrom,
        to: periodTo,
        operation_type: operationsType,
        operation_age: operationsAge,
        limits: {
          school_ids: orgIDs.map((id) => parseInt(id, 10)),
        },
      },
      options,
    },
    null,
  ]
}
